import { useTranslation } from "react-i18next";
import { IViewport } from "../../../Domain/Types/FloorPlan/Viewport.type";
import { Box, Grid2, IconButton, TextField } from "@mui/material";
import { AddBox, IndeterminateCheckBox } from "@mui/icons-material";
import { Icon } from "@iconify/react";

export function FloorFrameHandler({
  floorFrameChanges,
  handleFloorFramePlus,
  handleFloorFrameMinus,
  handleInterval
}: Readonly<{
  floorFrameChanges: IViewport;
  handleFloorFramePlus: () => void;
  handleFloorFrameMinus: () => void;
  handleInterval: (cb: () => void) => void;
}>) {
  const textFieldStyle = {
    width: "7rem",
    margin: "0 3px",
    backgroundColor: "#f0f0f0",
    opacity: 0.9,
    borderRadius: 3
  };
  const { t } = useTranslation();

  return (
    <Grid2
      data-testid={"frame-handle-container"}
      container
      sx={{ position: "absolute", top: "12%", left: "3%", width: "90%" }}
    >
      <Grid2 sx={{ display: "flex", flexDirection: "column" }} data-testid={"frame-handle-btn"}>
        <IconButton
          data-testid="btn-handle-plus"
          onMouseDown={() => handleInterval(handleFloorFramePlus)}
          size="large"
        >
          <AddBox fontSize="large" sx={{ color: "black" }} />
        </IconButton>
        <IconButton
          data-testid="btn-handle-minus"
          onMouseDown={() => handleInterval(handleFloorFrameMinus)}
          size="large"
        >
          <IndeterminateCheckBox fontSize="large" sx={{ color: "black" }} />
        </IconButton>
      </Grid2>
      <Grid2 data-testid={"frame-handle-textfield"}>
        <Box>
          <TextField
            sx={textFieldStyle}
            size="small"
            data-testid="viewport-scaler-width"
            label={t("Width")}
            value={floorFrameChanges.width}
            variant="filled"
            slotProps={{
              input: {
                style: { color: "black" },
                readOnly: true,
                endAdornment: <Icon icon={"radix-icons:width"} width={50} height={50} />
              },
              inputLabel: {
                style: { color: "black" }
              }
            }}
          />
          <TextField
            sx={textFieldStyle}
            value={floorFrameChanges.height}
            data-testid="viewport-scaler-height"
            label={t("Height")}
            size="small"
            variant="filled"
            slotProps={{
              input: {
                style: { color: "black" },
                readOnly: true,
                endAdornment: <Icon icon={"radix-icons:height"} width={50} height={50} />
              },
              inputLabel: {
                style: { color: "black" }
              }
            }}
          />
        </Box>
      </Grid2>
    </Grid2>
  );
}
